import * as _m from '@/models';
import { useEffect, useRef, useState } from 'react';
import { DeltaJsonElement } from '@/components/common/DeltaJsonElement';
import { useChannelPost } from '@/hooks/api/useChannelPost';
import { useChannelPostComments } from '@/hooks/api/useChannelPostComments';
import { SimpleTextFormat } from '@/components/common/SimpleTextFormat';
import ReactTimeAgo from 'react-time-ago';
import { useCreateChannelPostComment } from '@/hooks/api/useCreateChannelPostComment';
import { toastApiError, toastError } from '@/lib/toast';
import { useLoading } from '@/providers/LoadingProvider';

type Props = {
  channel: _m.Channel;
  channel_post: _m.ChannelPost;
};

export const ChannelPostComments = ({ channel, channel_post }: Props) => {
  const { setShowLoading } = useLoading();
  const [commentContent, setCommentContent] = useState('');
  const { data: comments, isError: isChannelPostError } = useChannelPostComments(channel.cid, channel_post.id);
  const [createdComments, setCreatedComments] = useState<_m.Comment[]>([]);
  const { mutate, data, error, isPending } = useCreateChannelPostComment();

  const onCommentSendClick = () => {
    setShowLoading(true);
    mutate({ cid: channel.cid, id: channel_post.id, content: commentContent });
  };

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => toastApiError(error), [error]);

  useEffect(() => {
    if (data) {
      setCommentContent('');
      createdComments.unshift(data);
    }
  }, [data]);
  if (comments == null) return <></>;

  return (
    <section className="post-comments">
      <div className="control-group">
        {createdComments.length + channel_post.comments_count > 0 && (
          <div className="label">{createdComments.length + channel_post.comments_count}件のコメント</div>
        )}

        <div className="control">
          <textarea
            maxLength={200}
            value={commentContent}
            onChange={(e) => setCommentContent(e.target.value)}
          ></textarea>
        </div>
      </div>
      <div className="control-group submit">
        <button className={`btn ${commentContent.length > 0 ? '' : 'disabled'}`} onClick={onCommentSendClick}>
          コメント
        </button>
      </div>
      <ul className="comments">
        {createdComments?.map((c) => (
          <li key={`c-${c.id}`}>
            <div className="time">
              <ReactTimeAgo date={new Date(c.created_at)} locale="ja" />
            </div>
            <p>
              <SimpleTextFormat content={c.content} />
            </p>
          </li>
        ))}
        {comments?.map((c) => (
          <li key={`c-${c.id}`}>
            <div className="time">
              <ReactTimeAgo date={new Date(c.created_at)} locale="ja" />
            </div>
            <p>
              <SimpleTextFormat content={c.content} />
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
};
